import { z } from "zod"

const ExtraUserAttributesSchema = z.object({
    employeeId: z.string(),
})

export const DartyAuthResponseSchema = z
    .object({
        name: z.string(),
        email: z.string(),
        oeBackendToken: z.string(),
        extraUserAttributes: z
            .string()
            .transform((str) => JSON.parse(str))
            .pipe(ExtraUserAttributesSchema),
    })
    .transform(({ name, oeBackendToken, extraUserAttributes }) => ({
        accessToken: oeBackendToken,
        user: {
            uid: extraUserAttributes.employeeId,
            fullname: name,
        },
    }))
